<template>
    <div>
        <div class="row">
            <div class="form-group col-md-8">
                <label for="provider_diagnosis">Diagnosis <small class="text-muted"><em>(Optional)</em></small></label>
                <textarea id="provider_diagnosis" name="provider_diagnosis" rows="2" v-bind:class="['form-control', {'is-invalid' : hasError('provider_diagnosis') }]" v-model="provider.diagnosis" :disabled="readonly"></textarea>
                <span v-if="hasError('provider_diagnosis')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_diagnosis')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-2">
                <label for="provider_cpt">CPT/DRG Code <small class="text-muted"><em>(Optional)</em></small></label>
                <textarea id="provider_cpt" name="provider_cpt" rows="2" v-bind:class="['form-control', {'is-invalid' : hasError('provider_cpt') }]" v-model="provider.cpt" :disabled="readonly"></textarea>
                <span v-if="hasError('provider_cpt')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_cpt')"></strong>
                </span>                  
            </div>
            <div class="form-group col-md-2">
                <label for="provider_icd">ICD/DSM Code <small class="text-muted"><em>(Optional)</em></small></label>
                <textarea id="provider_icd" name="provider_icd" rows="2" v-bind:class="['form-control', {'is-invalid' : hasError('provider_icd') }]" v-model="provider.icd" :disabled="readonly"></textarea>
                <span v-if="hasError('provider_icd')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_icd')"></strong>
                </span>                  
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label for="provider_treatment">Requested Treatment or Testing <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="provider_treatment" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('provider_treatment') }]" name="provider_treatment" v-model="provider.requested_treatment" :disabled="readonly">
                <span v-if="hasError('provider_treatment')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_treatment')"></strong>
                </span>                  
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label for="provider_reason">Reason for Treatment or Testing <small class="text-muted"><em>(Optional)</em></small></label>
                <input id="provider_reason" type="text" v-bind:class="['form-control', {'is-invalid' : hasError('provider_reason') }]" name="provider_reason" v-model="provider.reason_treatment" :disabled="readonly">
                <span v-if="hasError('provider_reason')" class="invalid-feedback" role="alert">
                    <strong v-text="errorText('provider_reason')"></strong>
                </span>                  
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label for="provider_additional_information">Additional Information <small class="text-muted"><em>(Optional) Limited to 140 characters</em></small></label>
                <textarea id="provider_additional_information" name="provider_additional_information" class="form-control" rows="2" maxlength="140" v-model="provider.additional_information" :disabled="readonly"></textarea>
            </div>
        </div>
    </div>        
</template>

<script>
export default {
    props: {
        errors: Object,
        model: Object,
        readonly: Boolean
    },
    data() {
        return {
            provider: this.model
        }
    },
    methods: {
        hasError: function (name) {
            return this.errors.hasOwnProperty(name);
        },
        errorText: function (name) {
            return this.errors[name][0];
        }
    }        
}
</script>

<style scoped>

</style>